import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import AxiosCustom from "common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
  selectMarketMakerAlgorithmicOption:
    "selectMarketMakerAlgorithmicOption [Action]",
  selectMarketMakerAlgorithmicOptionLoading:
    "selectMarketMakerAlgorithmicOptionLoading [Action]",
  selectMarketMakerAlgorithmicOptionAsync:
    "selectMarketMakerAlgorithmicOptionAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const select_market_maker_algorithmic_option_Reducer = (
  state = inistiaState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.selectMarketMakerAlgorithmicOption:
      return {
        ...state,
        data: payload?.results,
        total: payload?.total,
      };
    case actionTypes.selectMarketMakerAlgorithmicOptionLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.selectMarketMakerAlgorithmicOptionLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "market_maker",
    method_type: "select_market_maker_algorithmic_option",
    data: payload?.data ? payload.data : {},
    size: 10,
    from_: 0,
  };

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }
    yield put({
      type: actionTypes.selectMarketMakerAlgorithmicOption,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.selectMarketMakerAlgorithmicOptionLoading,
      payload: false,
    });
  }
}

export function* selectMarketMakerAlgorithmicOption() {
  yield takeLatest(
    actionTypes.selectMarketMakerAlgorithmicOptionAsync,
    handleWorker
  );
}
